import React from 'react';

const Loader = () => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(255,255,255,0.8)',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px'
  }}>
    <div className="bouncing-loader">
      <div></div><div></div><div></div>
    </div>
    <p style={{ 
      color: '#333', 
      fontSize: '18px', 
      fontWeight: '600',
      margin: 0,
      textAlign: 'center',
      textShadow: '0 1px 2px rgba(0,0,0,0.1)'
    }}>
      Data is loading, please wait...
    </p>
    <style>
      {`
      .bouncing-loader {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        height: 60px;
        gap: 10px;
      }
      .bouncing-loader div {
        width: 18px;
        height: 18px;
        background: linear-gradient(135deg, #ff6600 40%, #ffa500 100%);
        border-radius: 50%;
        animation: bouncing-loader 0.6s infinite alternate;
        box-shadow: 0 4px 16px rgba(255, 102, 0, 0.2);
      }
      .bouncing-loader div:nth-child(2) {
        animation-delay: 0.2s;
      }
      .bouncing-loader div:nth-child(3) {
        animation-delay: 0.4s;
      }
      @keyframes bouncing-loader {
        to {
          transform: translateY(-30px) scale(1.1);
          box-shadow: 0 16px 32px rgba(255, 102, 0, 0.3);
        }
      }
      `}
    </style>
  </div>
);

export default Loader; 